import { Pipe, PipeTransform } from '@angular/core';
import { WagtailButtonTypes } from "@gea-waldviertler-website/gea-models";

@Pipe({
    name: 'wagtailButtonClass',
    standalone: false
})
export class WagtailButtonClassPipe implements PipeTransform {
  transform(v: WagtailButtonTypes): string {
    switch (v) {
      case 'button-secondary-black': return 'btn-black'
      case 'button-secondary-white': return 'btn-white'
      case 'button-secondary-green': return 'btn-green'
      default: return 'btn-primary'
    }
  }
}
